<template>
  <div>
    <div style="overflow: hidden;">
      <template>
        <v-layout row justify-center>
          <div
            v-if="dialog"
            style="position: fixed; top: 0; left: 0; z-index: 1000; background-color: rgba(0,0,0,.3); width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center;"
          >
            <v-card
              style="text-align: center; width: 900px; max-height: 100%; overflow: auto;"
            >
              <v-card-text>
                <v-btn
                  color="red darken-1"
                  small
                  fab
                  @click="dialog = false"
                  style="color:#fff; margin-left:95%; border-radius: 50%;"
                  ><v-icon dark>close</v-icon></v-btn
                >
                <!-- <div
                  style="
                    background: #fff3cd;
                    border: 1px solid #ffeeba;
                    border-left: 6px solid #dc3545;
                    color: #856404;
                    padding: 15px;
                    border-radius: 6px;
                    margin-bottom: 15px;
                    font-size: 15px;
                    line-height: 1.8;
                    margin-top: 10px;
                  "
                >
                  <h3
                    style="color: #dc3545; text-align: center; margin-bottom: 10px;"
                  >
                    ২০২৩ সালের প্রিলিমিনারী টু মাস্টার্স পরীক্ষার রোল নম্বর
                    সংশোধন সংক্রান্ত জরুরী বিজ্ঞপ্তি
                  </h3>

                  <p style="margin-bottom: 10px;">
                    সংশ্লিষ্ট সকলকে জানানো যাচ্ছে যে, ২০২৩ সালের প্রিলিমিনারী টু
                    মাস্টার্স পরীক্ষায় অংশ গ্রহণের জন্য ইতোমধ্যে যে সকল
                    পরীক্ষার্থীর প্রবেশপত্র ডাউনলোড করা হয়েছে তাদের রোল নম্বরের
                    প্রথম তিন ডিজিট
                    <b>"৩০০"</b> এর পরিবর্তে <b>"৩০"</b> হবে এবং ডান পার্শ্বের
                    শেষ <b>৫ (পাঁচ)</b> ডিজিট অপরিবর্তিত থাকবে।
                  </p>

                  <table
                    style="
                      width: 100%;
                      border-collapse: collapse;
                      text-align: center;
                      margin-top: 10px;
                    "
                  >
                    <thead>
                      <tr style="background: #f8d7da;">
                        <th style="border:1px solid #999; padding:8px;">
                          ভুল রোল নম্বর
                        </th>
                        <th style="border:1px solid #999; padding:8px;">
                          সংশোধিত রোল নম্বর
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="border:1px solid #999; padding:8px;">
                          ৩০০২৩৭৫৫
                        </td>
                        <td style="border:1px solid #999; padding:8px;">
                          ৩০২৩৭৫৫
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <p style="margin-bottom: 10px; margin-top: 10px;">
                    সংশোধিত রোল নম্বর সম্বলিত প্রবেশপত্র নতুন করে ডাউনলোড করে পরীক্ষার্থীদের মধ্যে বিতরণের জন্য সংশ্লিষ্ট
                    সকল কলেজকে অনুরোধ করা হলো। নতুন করে হাজিরা শীট ডাউনলোড করার প্রয়োজন নাই।
                  </p>
                </div> -->
                <v-divider></v-divider>
                <div class="attendance-banner">
                  <a
                    href="https://attendance.nu.ac.bd/login"
                    class="nav-link active navigation__list"
                    aria-selected="false"
                  >
                    Click here to Attendance Login
                  </a>

                  <img
                    :src="require('@/assets/images/att_not.png')"
                    style="height: auto;"
                    alt="Drag and Drop"
                  />
                </div>
                <!-- <v-icon style="font-size: 110px; color: red;">error</v-icon> 
                <div style="margin-top: 20px;">
                  <h3 style="color: black; line-height: 50px;">"আজ <span style="color: red;">১০/০৬/২০২৬</span> ইং তারিখ বিকাল <span style="color: red;">৬:০০</span> ঘটিকা পর্যন্ত <br> <b>EMS</b> সফটওয়্যারের মাধ্যমে <br><b>'Form Fill-up' এবং ‘Incourse Marks Entry’</b> সংক্রান্ত <br> সকল কার্যক্রম <span style="color: red;">সাময়িকভাবে বন্ধ থাকবে</span> ।"  -->
                <!-- <br><br>" সাময়িক সময়ের জন্য <b>EMS</b> সফটওয়ারের মাধ্যমে শুধু মাত্র <br> <b>Admit Card</b>, <b>Descriptive Roll Sheet</b> এবং <b>Attendance Sheet</b> ডাউনলোড করা যাবে । "
                     
                    <br><br>" আগামী ২৫ জুন ২০২৫ ইং তারিখ হতে <b>Form Fill-up</b> <br> (বর্ধিত সময় সহ) এর কার্যক্রম চালু থাকিবে । " -->
                <!-- </h3>
                </div> -->
                <!-- <div style="margin-top: 20px;">
                  <h3 style="color: red;">
                    "২০২২ সালের প্রিলিমিনারি টু মাস্টার্স পরীক্ষার    E - type (OMR) পরীক্ষা শেষে ৬ মাস পর্যন্ত   কেন্দ্রে  সংরক্ষণ করতে হবে।"
                     <br><br>" সাময়িক সময়ের জন্য <b>EMS</b> সফটওয়ারের মাধ্যমে শুধু মাত্র <br> <b>Admit Card</b>, <b>Descriptive Roll Sheet</b> এবং <b>Attendance Sheet</b> ডাউনলোড করা যাবে । "
                     
                    <br><br>" আগামী ২৫ জুন ২০২৫ ইং তারিখ হতে <b>Form Fill-up</b> <br> (বর্ধিত সময় সহ) এর কার্যক্রম চালু থাকিবে । "
                  </h3>
                </div> -->
              </v-card-text>
            </v-card>
          </div>
        </v-layout>
      </template>
    </div>

    <Header :fromHome="true"></Header>

    <!--Full width header End-->

    <!-- Main content Start -->
    <div class="main-content">
      <!-- Banner Section Start -->
      <div id="rs-banner" class="rs-banner style6">
        <div class="container">
          <div class="banner-content text-center">
            <h1 class="banner-title white-color">
              NU Examination Management System
            </h1>
          </div>
        </div>
      </div>
      <!-- Banner Section End -->

      <div id="rs-about" class="rs-about style6 pt-10 pb-80 bg4">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-3">
                  <div
                    class="nav flex-column nav-pills"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <router-link
                      to="/login?module=admin"
                      class="nav-link active navigation__list"
                      aria-selected="true"
                      >NU Admin Login</router-link
                    >
                    <router-link
                      to="/student-login"
                      class="nav-link navigation__list"
                      aria-selected="false"
                      >Student login</router-link
                    >
                    <router-link
                      to="/c-login"
                      class="nav-link navigation__list"
                      aria-selected="false"
                      >College login (Admin)</router-link
                    >
                    <router-link
                      to="/cu-login"
                      class="nav-link navigation__list"
                      aria-selected="false"
                      >College User login (Department)</router-link
                    >
                    <router-link
                      to="/login?module=center"
                      class="nav-link navigation__list"
                      aria-selected="false"
                      >Center/Regional-center login</router-link
                    >
                    <a
                      href="https://attendance.nu.ac.bd/login"
                      class="nav-link navigation__list"
                      aria-selected="false"
                    >
                      Attendance Login
                    </a>
                    <!-- <router-link 
                      to="/login?module=center-user"
                      class="nav-link navigation__list"
                      aria-selected="false"
                      >Center Department User login <br />
                      ( For Practical & Viva )
                    </router-link> -->
                    <!-- <router-link
                      to="/login"
                      class="nav-link navigation__list"
                      aria-selected="false"
                      >NU User login</router-link
                    > -->
                    <!-- <router-link
                      to="/login"
                      class="nav-link navigation__list"
                      aria-selected="false"
                      >Examiner/Head-Examiner Web login</router-link
                    > -->
                    <!-- <router-link
                        to="/login"
                        class="nav-link navigation__list"
                        aria-selected="false"
                        >Invigilator Web login</router-link
                      >
                      <router-link
                        to="/org-login"
                        class="nav-link navigation__list"
                        aria-selected="false"
                        >Organization login</router-link
                      > -->
                  </div>
                </div>
                <div class="col-lg-9">
                  <div class="tab-content" id="v-pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="v-pills-home"
                      role="tabpanel"
                      aria-labelledby="v-pills-home-tab"
                    >
                      <div class="information">
                        <!-- <p class="">
                          Development and implementation of Examination
                          Management System (EMS) for National University
                        </p> -->
                        <h2>Introduction:</h2>

                        <p>
                          The broad objective of the envisaged System is to
                          automate the entire process of the Examination
                          Division to provide better services in a paperless
                          environment to serve the Students and Staffs of the
                          University. This system will speed up the information
                          flow among different sectors/sections of Examination
                          Division for better Transparency, reliability and
                          timely execution of the work Process. By this software
                          users can share and get the information optimally in a
                          better way for efficient decision- making with
                          increased accountability. For the EMS it will be
                          better and timely addressing of the grievances of the
                          Students and Colleges. This will be easy to integrate
                          with the existing Enterprise Resource Planning (ERP)
                          and to make it compatible with Mobile Environment.
                        </p>
                        <p>
                          EMS is introducing the state of the art data logging
                          for all event points and maintain intelligent system
                          for assisting NU for the overall process beyond answer
                          sheet tracking and error manageability. To make the
                          process real time at site and to automate the script
                          distribution to reduce current logistics and resources
                          pressure this software will be very helpful. Ems will
                          minimize data loss in legitimate work both by student
                          and examiner. By using this EMS software, it will
                          reduce the result processing time to a minimum level.
                          Ensuring secure data transfer at all points of the EMS
                          with proper encryption techniques will be accurate.
                          Implementation of the result approval and correction
                          system with highest level of security will be possible
                          with this system.
                        </p>
                        <p>
                          The purpose of introducing the software is to
                          integrate the current payment system and also ensuring
                          options for future charging mechanism and payment
                          environment. Identify the processes running in manual
                          and breakdown those processes into sub- processes in
                          order to optimize the processing times. It will be
                          very easy to identify the stakeholders, tasks and
                          roles and bridging the stakeholders through the
                          product clearly by using this software.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="shape-animate">
            <div class="transparent left">
              <img
                :src="require('@/assets/images/about/home6/line/1.png')"
                alt="images"
              />
            </div>
            <div class="transparent right">
              <img
                :src="require('@/assets/images/about/home6/line/2.png')"
                alt="images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Main content End -->
    <Footer></Footer>
  </div>
</template>

<script>
// import carousel from "@/components/utils/carousel.vue";
import Footer from "@/views/util/footer.vue";
import Header from "@/views/util/header.vue";
export default {
  components: {
    // carousel
    Footer,
    Header,
  },
  data() {
    return {
      dialog: false,
    };
  },
  created() {
    this.collPoper();
  },
  mounted() {
    var date = new Date().toLocaleString();
    console.log("current date and time: ", date);
  },
  methods: {
    collPoper() {
      this.dialog = true;
    },
  },
};
</script>

<style scoped src="@/assets/css/bootstrap.min.css"></style>
<style scoped src="@/assets/css/font-awesome.min.css"></style>
<style scoped src="@/assets/css/animate.css"></style>
<style scoped src="@/assets/css/rsmenu-main.css"></style>
<style scoped src="@/assets/css/style.css"></style>
<style scoped src="@/assets/css/responsive.css"></style>
<style>
.v-dialog__content .v-dialog__content--active {
  z-index: 1000;
}

.attendance-banner {
  position: relative;
  display: inline-block;
}

.attendance-image {
  display: block;
  width: 100%;
  height: auto;
}

.attendance-link {
  position: absolute;
  top: 15px; /* Distance from top */
  left: 20px; /* Distance from left */
  z-index: 10;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  background: rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  border-radius: 5px;
}

.attendance-link:hover {
  text-decoration: underline;
}
</style>
